/* ============================================================
   MAHAFOOD — mf-stock-sync.js v3.0
   E-Mail via Klaviyo + WhatsApp via N8N → Twilio
   ============================================================ */

(function () {
  'use strict';

  /* ── Konfiguration — HIER ANPASSEN ── */
  const CONFIG = {
    klaviyoPublicKey: 'VDsmCF',   
    n8nWebhookUrl:    'https://n8n.mahafood.de/webhook/back-in-stock',
    countryCode:      '+49',                             
    shopName:         'Mahafood'
  };

  /* ── DOM Elemente ── */
  const modal        = document.getElementById('mf-notify-modal');
  const productName  = document.getElementById('mf-modal-product-name');
  const stepChannel  = document.getElementById('mf-step-channel');
  const stepEmail    = document.getElementById('mf-step-email');
  const stepWhatsapp = document.getElementById('mf-step-whatsapp');
  const stepSuccess  = document.getElementById('mf-step-success');
  const emailInput   = document.getElementById('mf-email-input');
  const phoneInput   = document.getElementById('mf-phone-input');
  const emailSubmit  = document.getElementById('mf-email-submit');
  const waSubmit     = document.getElementById('mf-wa-submit');
  const waConsent    = document.getElementById('mf-wa-consent');
  const successText  = document.getElementById('mf-success-text');

  let activeProductId  = null;
  let activeVariantId  = null;
  let activeProductTitle = null;

  /* ─────────────────────────────────────────
     Modal öffnen / schließen
  ───────────────────────────────────────── */
  function openModal(btn) {
    activeProductId    = btn.dataset.productId;
    activeVariantId    = btn.dataset.variantId;
    activeProductTitle = btn.dataset.productTitle || '';
    const varTitle     = btn.dataset.variantTitle || '';

    if (productName) {
      productName.textContent = varTitle && varTitle !== 'Default Title'
        ? `${activeProductTitle} — ${varTitle}`
        : activeProductTitle;
    }

    showStep('channel');
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    activeProductId = activeVariantId = activeProductTitle = null;
  }

  /* ─────────────────────────────────────────
     Schritte anzeigen
  ───────────────────────────────────────── */
  function showStep(step) {
    stepChannel.hidden  = step !== 'channel';
    stepEmail.hidden    = step !== 'email';
    stepWhatsapp.hidden = step !== 'whatsapp';
    stepSuccess.hidden  = step !== 'success';
  }

  /* ─────────────────────────────────────────
     Events
  ───────────────────────────────────────── */
if (window._mfStockSyncLoaded) return;
window._mfStockSyncLoaded = true;

document.addEventListener('click', function (e) {

    /* Notify-Button öffnet Modal */
    const nb = e.target.closest('[data-notify-btn]');
    if (nb) { e.preventDefault(); openModal(nb); return; }

    /* Modal schließen */
    if (e.target.closest('[data-modal-close]')) { closeModal(); return; }

    /* Zurück */
    if (e.target.closest('[data-back]')) { showStep('channel'); return; }

    /* Kanal wählen */
    const ch = e.target.closest('[data-channel]');
    if (ch) {
      showStep(ch.dataset.channel);
      if (ch.dataset.channel === 'email') setTimeout(() => emailInput?.focus(), 80);
      if (ch.dataset.channel === 'whatsapp') setTimeout(() => phoneInput?.focus(), 80);
      return;
    }
  });

  /* ESC-Taste */
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && !modal?.hidden) closeModal();
  });

  /* ─────────────────────────────────────────
     E-Mail absenden → Klaviyo
  ───────────────────────────────────────── */
  emailSubmit?.addEventListener('click', async function () {
    const email = emailInput.value.trim();
    if (!isValidEmail(email)) {
      shake(emailInput); emailInput.focus(); return;
    }

    setLoading(emailSubmit, true, 'Wird gespeichert…');

    try {
      const res = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${CONFIG.klaviyoPublicKey}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-02-15'
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: email }
                  }
                },
                channels: ['EMAIL']
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${activeVariantId}`
                  }
                }
              }
            }
          })
        }
      );

      if (!res.ok && res.status !== 202) throw new Error(`Klaviyo ${res.status}`);

      successText.textContent =
        `Wir schreiben dir an ${email}, sobald "${activeProductTitle}" wieder verfügbar ist.`;
      showStep('success');

    } catch (err) {
      console.error('[Mahafood] Klaviyo Fehler:', err);
      setLoading(emailSubmit, false, 'Per E-Mail benachrichtigen');
      showError(emailSubmit, 'Fehler — bitte erneut versuchen');
    }
  });

  /* ─────────────────────────────────────────
     WhatsApp absenden → N8N → Twilio
  ───────────────────────────────────────── */
  waSubmit?.addEventListener('click', async function () {
    const phone   = phoneInput.value.trim().replace(/\s/g, '');
    const consent = waConsent?.checked;

    if (!phone || phone.length < 7) { shake(phoneInput); phoneInput.focus(); return; }
    if (!consent) {
      shake(document.querySelector('.mf-consent__box'));
      return;
    }

    /* Nummer normalisieren: 0176... → +49176... */
    let normalized = phone;
    if (normalized.startsWith('0')) {
      normalized = CONFIG.countryCode + normalized.slice(1);
    } else if (!normalized.startsWith('+')) {
      normalized = CONFIG.countryCode + normalized;
    }

    setLoading(waSubmit, true, 'Wird gespeichert…');

    try {
      const res = await fetch(CONFIG.n8nWebhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          channel:       'whatsapp',
          phone:         normalized,
          product_id:    activeProductId,
          variant_id:    activeVariantId,
          product_title: activeProductTitle,
          shop:          window.Shopify?.shop || location.hostname,
          consent:       true,
          timestamp:     new Date().toISOString()
        })
      });

      if (!res.ok) throw new Error(`N8N ${res.status}`);

      successText.textContent =
        `Wir schicken dir eine WhatsApp an ${normalized}, sobald "${activeProductTitle}" wieder verfügbar ist.`;
      showStep('success');

    } catch (err) {
      console.error('[Mahafood] WhatsApp Fehler:', err);
      setLoading(waSubmit, false, 'Per WhatsApp benachrichtigen');
      showError(waSubmit, 'Fehler — bitte erneut versuchen');
    }
  });

  /* ─────────────────────────────────────────
     Varianten-Wechsel auf Produktseite
  ───────────────────────────────────────── */
  document.addEventListener('variant:change', function (e) {
    const v = e.detail?.variant;
    if (!v) return;
    document.querySelectorAll('[data-notify-btn]').forEach(btn => {
      btn.dataset.variantId    = v.id;
      btn.dataset.variantTitle = v.title;
    });
  });

  /* ─────────────────────────────────────────
     Hilfsfunktionen
  ───────────────────────────────────────── */
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function setLoading(btn, loading, text) {
    btn.disabled = loading;
    const span = btn.querySelector('.mf-submit-btn__text');
    if (span) span.textContent = text;
  }

  function shake(el) {
    if (!el) return;
    el.style.animation = 'none';
    el.getBoundingClientRect();
    el.style.animation = 'mf-shake 0.4s ease';
    el.addEventListener('animationend', () => el.style.animation = '', { once: true });
  }

  function showError(btn, msg) {
    const span = btn.querySelector('.mf-submit-btn__text');
    if (span) {
      span.textContent = msg;
      setTimeout(() => {
        const orig = btn.id === 'mf-email-submit'
          ? 'Per E-Mail benachrichtigen'
          : 'Per WhatsApp benachrichtigen';
        span.textContent = orig;
      }, 3000);
    }
  }

  /* Shake-Animation dynamisch einfügen */
  const style = document.createElement('style');
  style.textContent = `
    @keyframes mf-shake {
      0%,100%{transform:translateX(0)}
      20%{transform:translateX(-6px)}
      40%{transform:translateX(6px)}
      60%{transform:translateX(-4px)}
      80%{transform:translateX(4px)}
    }
  `;
  document.head.appendChild(style);

})();